function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FYI-Document-Icons",
  transform: "translate(-216.000000, -836.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Zipped",
  transform: "translate(0.000000, 808.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#735FAD",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7,32 L5,32 L5,31 L7,31 L7,28 L5,28 L5,27 L7,27 L7,24 L5,24 L5,23 L7,23 L7,20 L5,20 L5,19 L7,19 L7,16 L5,16 L5,15 L7,15 L7,12 L5,12 L5,11 L7,11 L9,11 L9,13 L11,13 L11,14 L9,14 L9,17 L11,17 L11,18 L9,18 L9,21 L11,21 L11,22 L9,22 L9,25 L11,25 L11,26 L9,26 L9,29 L11,29 L11,30 L9,30 L9,33 L11,33 L11,34 L9,34 L7,34 L7,32 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#A28AE8",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.125000, 0.000000)",
  fill: "#637282",
  fillRule: "nonzero",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.15268677e-05,0 L2.18750843,0 L2.18750843,1.5234375 L7.15268677e-05,1.5234375 L7.15268677e-05,0 Z M2.18750843,1.5234375 L4.37494534,1.5234375 L4.37494534,3.046875 L2.18750843,3.046875 L2.18750843,1.5234375 Z M7.15268677e-05,3.046875 L2.18750843,3.046875 L2.18750843,4.5703125 L7.15268677e-05,4.5703125 L7.15268677e-05,3.046875 Z M2.18750843,4.5703125 L4.37494534,4.5703125 L4.37494534,6.09375 L2.18750843,6.09375 L2.18750843,4.5703125 Z M7.15268677e-05,6.09375 L2.18750843,6.09375 L2.18750843,7.6171875 L7.15268677e-05,7.6171875 L7.15268677e-05,6.09375 Z M2.18750843,7.6171875 L4.37494534,7.6171875 L4.37494534,9.140625 L2.18750843,9.140625 L2.18750843,7.6171875 Z M7.15268677e-05,9.140625 L2.18750843,9.140625 L2.18750843,10.6640625 L7.15268677e-05,10.6640625 L7.15268677e-05,9.140625 Z M2.18750843,10.6640625 L4.37494534,10.6640625 L4.37494534,12.1875 L2.18750843,12.1875 L2.18750843,10.6640625 Z M7.15268677e-05,12.1875 L2.18750843,12.1875 L2.18750843,13.7109375 L7.15268677e-05,13.7109375 L7.15268677e-05,12.1875 Z M2.18750843,13.7109375 L4.37494534,13.7109375 L4.37494534,15.234375 L2.18750843,15.234375 L2.18750843,13.7109375 Z M7.15268677e-05,15.234375 L2.18750843,15.234375 L2.18750843,16.7578125 L7.15268677e-05,16.7578125 L7.15268677e-05,15.234375 Z M7.15268677e-05,16.7578125 L4.37494534,16.7578125 L4.37494534,23.6163281 C4.37699246,23.8162895 4.32146954,24.0090662 4.22077382,24.151615 C4.12007809,24.2941637 3.98259548,24.374613 3.83902329,24.375 L0.535993568,24.375 C0.392329144,24.3750267 0.254672323,24.2947086 0.153912096,24.1520686 C0.053151869,24.0094285 -0.00227401604,23.8164112 7.15268677e-05,23.6163281 L7.15268677e-05,16.7578125 Z M1.09378998,21.328125 L1.09378998,22.8515625 L3.28122688,22.8515625 L3.28122688,21.328125 L1.09378998,21.328125 Z"
}))));

var SvgZip = function SvgZip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zip.6fd75306.svg";
export { ForwardRef as ReactComponent };